/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debtor_Legal_NameInputs */

const en_case_field_debtor_legal_name = /** @type {(inputs: Case_Field_Debtor_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal name`)
};

const pt_br2_case_field_debtor_legal_name = /** @type {(inputs: Case_Field_Debtor_Legal_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razão social`)
};

/**
* | output |
* | --- |
* | "Legal name" |
*
* @param {Case_Field_Debtor_Legal_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debtor_legal_name = /** @type {((inputs?: Case_Field_Debtor_Legal_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debtor_Legal_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debtor_legal_name(inputs)
	return pt_br2_case_field_debtor_legal_name(inputs)
});